import type { DragEvent } from "react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import i18n from "../../../../../../services/i18n";
import { AppIconButton } from "../../../../../../shared/components/AppIconButton";
import { SmallXIcon } from "../../../../../../shared/icons/SmallXIcon";
import { removeLeadingSlash } from "../../../../helpers";
import type { ServiceLink } from "../../../../types";
import styles from "./styles.module.css";

interface Props {
  visibleLinks: string[];
  onDeleteVisibleLink: (link: ServiceLink) => void;
  handleDragStart: (e: DragEvent<HTMLLIElement>, index: number) => void;
  handleDragOver: (e: DragEvent<HTMLLIElement>) => void;
  handleDrop: (e: DragEvent<HTMLLIElement>, index: number) => void;
}

export const VisibleServiceLinks = ({
  visibleLinks,
  onDeleteVisibleLink,
  handleDragStart,
  handleDragOver,
  handleDrop,
}: Props) => {
  const { t } = useTranslation();

  const sortedVisibleLinks = useMemo(() => {
    return [...visibleLinks].sort((a, b) => {
      const nameA = t(`header.${removeLeadingSlash(a)}`);
      const nameB = t(`header.${removeLeadingSlash(b)}`);
      return nameA.localeCompare(nameB);
    });
  }, [visibleLinks, t, i18n.language]);

  return (
    <div className={styles["visible-links-container"]}>
      <div>{`Доступно для добавления: ${6 - visibleLinks.length}`}</div>
      <ul className={styles["visible-link-list"]}>
        {sortedVisibleLinks.map((link, index) => (
          <li
            key={`${link}-${index}`}
            onDragStart={(e) => handleDragStart(e, index)}
            onDragOver={handleDragOver}
            onDrop={(e) => handleDrop(e, index)}
            draggable
            className={styles["visible-link-item"]}
          >
            <span>{t(`header.${removeLeadingSlash(link)}`)}</span>
            <AppIconButton
              onClick={() => onDeleteVisibleLink(link as ServiceLink)}
            >
              <SmallXIcon />
            </AppIconButton>
          </li>
        ))}
      </ul>
    </div>
  );
};
